module.exports = __webpack_public_path__ + "static/media/404.265e985b.svg";